import classNames from 'classnames';
import { FunctionComponent, PropsWithChildren } from 'react';
import { NavigationBarProps } from './NavigationBarProps';

export const NavigationBar: FunctionComponent<PropsWithChildren<NavigationBarProps>> = ({
  title,
  style = 'default',
  position = 'default',
  children
}) => {
  const translucentStyle: string = 'bg-gradient-to-b from-nav-top to-nav-bottom';
  const absolutePositionStyle: string = 'absolute top-0 left-0 right-0';
  return (
    <div
      className={classNames(
        'z-20 px-8 py-4 w-full h-stack justify-between items-center',
        style === 'translucent' ? translucentStyle : undefined,
        position === 'absolute' ? absolutePositionStyle : undefined
      )}
    >
      {title ? <h1 className="large-title">{title}</h1> : <div />}
      <div className="items-center space-x-3 h-stack">{children}</div>
    </div>
  );
};
